import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ButtonConnect from './ButtonConnect';
import ButtonConnected from './ButtonConnected';

import './Card.css';

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Card = props => {
  const { onClick, selected, name, logo, title } = props;
  const handleClick = () => onClick(props);
  const active = selected.includes(props.name);

  return (
    <div
      className={`accounts-card ${(selected.includes(name)) ? 'active' : ''}`}
    >
      <img className="accounts-card__logo" src={logo} alt={name} />

      <h4 className="accounts-card__title">{title}</h4>

      <ButtonsContainer>
        {active
          ? (
            <ButtonConnected
              onClick={handleClick}
              data-test="button"
            />
          ) : (
            <ButtonConnect
              onClick={handleClick}
              data-test="button"
            />
          )
        }
      </ButtonsContainer>
    </div>
  );
};

Card.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/common/accounts/components/card/Card.jsx